// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type UserEventsQueryVariables = Types.Exact<{
  filter: Types.UserEventFilter;
  limit: Types.Scalars['Int']['input'];
  order: Types.UserEventOrder;
}>;


export type UserEventsQuery = { __typename?: 'Query', userEvents: Array<{ __typename?: 'UserEvent', id: string, type: Types.UserEventType, createdAt: Types.Scalars['DateTime']['input'], payload?: any | null | undefined, parentTypeName: string, parent:
      | { __typename?: 'Approval', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'Bill', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'ChangeEvent', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'Commitment', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'CommitmentChangeOrder', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'Document', id: string, name: string, displayName: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'Estimate', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'HomeownerContractChangeOrder', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'Invoice', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'ItemTemplate', id: string, name: string }
      | { __typename?: 'JobLog', id: string, logDate: Types.Scalars['Date']['input'] }
      | { __typename?: 'JobLogImage', id: string, jobLog: { __typename?: 'JobLog', id: string, logDate: Types.Scalars['Date']['input'] } }
      | { __typename?: 'JobLogNote', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string }, jobLog: { __typename?: 'JobLog', id: string, logDate: Types.Scalars['Date']['input'] } }
      | { __typename?: 'StandaloneProject', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'Region', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'Market', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'Community', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'Subdivision', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'Lot', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'Structure', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'Unit', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'ProjectItem', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'ProjectLotDetail' }
      | { __typename?: 'ProjectReadyPlanConfig', id: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'ReadyPlan', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'PlanPackage', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'DesignPackage', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'ProductOffering', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'ReadyPlanOption', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'ToDo', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'ChangeRequestToDo', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'PunchlistItemTodo', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'Task', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'ScheduleTask', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'PlanTask', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'WarrantyTicket', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    , project?:
      | { __typename?: 'StandaloneProject', id: string, name: string, status: { __typename?: 'ProjectStatusDetail', code: Types.ProjectStatus } }
      | { __typename?: 'Region', id: string, name: string, status: { __typename?: 'ProjectStatusDetail', code: Types.ProjectStatus } }
      | { __typename?: 'Market', id: string, name: string, status: { __typename?: 'ProjectStatusDetail', code: Types.ProjectStatus } }
      | { __typename?: 'Community', id: string, name: string, status: { __typename?: 'ProjectStatusDetail', code: Types.ProjectStatus } }
      | { __typename?: 'Subdivision', id: string, name: string, status: { __typename?: 'ProjectStatusDetail', code: Types.ProjectStatus } }
      | { __typename?: 'Lot', id: string, name: string, status: { __typename?: 'ProjectStatusDetail', code: Types.ProjectStatus } }
      | { __typename?: 'Structure', id: string, name: string, status: { __typename?: 'ProjectStatusDetail', code: Types.ProjectStatus } }
      | { __typename?: 'Unit', id: string, name: string, status: { __typename?: 'ProjectStatusDetail', code: Types.ProjectStatus } }
     | null | undefined, cohort?: { __typename?: 'Cohort', id: string, name: string } | null | undefined, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, createdFor?: { __typename?: 'User', id: string, name: string } | null | undefined, createdBy: { __typename?: 'User', id: string, name: string }, comment?: { __typename?: 'Comment', id: string, html: string, author: { __typename?: 'User', name: string, id: string } } | null | undefined }> };

export type UserEventDetailFragment = { __typename?: 'UserEvent', id: string, type: Types.UserEventType, createdAt: Types.Scalars['DateTime']['input'], payload?: any | null | undefined, parentTypeName: string, parent:
    | { __typename?: 'Approval', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'Bill', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'ChangeEvent', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'Commitment', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'CommitmentChangeOrder', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'Document', id: string, name: string, displayName: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'Estimate', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'HomeownerContractChangeOrder', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'Invoice', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'ItemTemplate', id: string, name: string }
    | { __typename?: 'JobLog', id: string, logDate: Types.Scalars['Date']['input'] }
    | { __typename?: 'JobLogImage', id: string, jobLog: { __typename?: 'JobLog', id: string, logDate: Types.Scalars['Date']['input'] } }
    | { __typename?: 'JobLogNote', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string }, jobLog: { __typename?: 'JobLog', id: string, logDate: Types.Scalars['Date']['input'] } }
    | { __typename?: 'StandaloneProject', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'Region', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'Market', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'Community', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'Subdivision', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'Lot', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'Structure', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'Unit', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'ProjectItem', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'ProjectLotDetail' }
    | { __typename?: 'ProjectReadyPlanConfig', id: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'ReadyPlan', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'PlanPackage', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'DesignPackage', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'ProductOffering', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'ReadyPlanOption', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'ToDo', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'ChangeRequestToDo', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'PunchlistItemTodo', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'Task', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'ScheduleTask', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'PlanTask', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'WarrantyTicket', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
  , project?:
    | { __typename?: 'StandaloneProject', id: string, name: string, status: { __typename?: 'ProjectStatusDetail', code: Types.ProjectStatus } }
    | { __typename?: 'Region', id: string, name: string, status: { __typename?: 'ProjectStatusDetail', code: Types.ProjectStatus } }
    | { __typename?: 'Market', id: string, name: string, status: { __typename?: 'ProjectStatusDetail', code: Types.ProjectStatus } }
    | { __typename?: 'Community', id: string, name: string, status: { __typename?: 'ProjectStatusDetail', code: Types.ProjectStatus } }
    | { __typename?: 'Subdivision', id: string, name: string, status: { __typename?: 'ProjectStatusDetail', code: Types.ProjectStatus } }
    | { __typename?: 'Lot', id: string, name: string, status: { __typename?: 'ProjectStatusDetail', code: Types.ProjectStatus } }
    | { __typename?: 'Structure', id: string, name: string, status: { __typename?: 'ProjectStatusDetail', code: Types.ProjectStatus } }
    | { __typename?: 'Unit', id: string, name: string, status: { __typename?: 'ProjectStatusDetail', code: Types.ProjectStatus } }
   | null | undefined, cohort?: { __typename?: 'Cohort', id: string, name: string } | null | undefined, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, createdFor?: { __typename?: 'User', id: string, name: string } | null | undefined, createdBy: { __typename?: 'User', id: string, name: string }, comment?: { __typename?: 'Comment', id: string, html: string, author: { __typename?: 'User', name: string, id: string } } | null | undefined };

export type UserEventDetailProject_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, name: string, status: { __typename?: 'ProjectStatusDetail', code: Types.ProjectStatus } };

export type UserEventDetailProject_Region_Fragment = { __typename?: 'Region', id: string, name: string, status: { __typename?: 'ProjectStatusDetail', code: Types.ProjectStatus } };

export type UserEventDetailProject_Market_Fragment = { __typename?: 'Market', id: string, name: string, status: { __typename?: 'ProjectStatusDetail', code: Types.ProjectStatus } };

export type UserEventDetailProject_Community_Fragment = { __typename?: 'Community', id: string, name: string, status: { __typename?: 'ProjectStatusDetail', code: Types.ProjectStatus } };

export type UserEventDetailProject_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, name: string, status: { __typename?: 'ProjectStatusDetail', code: Types.ProjectStatus } };

export type UserEventDetailProject_Lot_Fragment = { __typename?: 'Lot', id: string, name: string, status: { __typename?: 'ProjectStatusDetail', code: Types.ProjectStatus } };

export type UserEventDetailProject_Structure_Fragment = { __typename?: 'Structure', id: string, name: string, status: { __typename?: 'ProjectStatusDetail', code: Types.ProjectStatus } };

export type UserEventDetailProject_Unit_Fragment = { __typename?: 'Unit', id: string, name: string, status: { __typename?: 'ProjectStatusDetail', code: Types.ProjectStatus } };

export type UserEventDetailProjectFragment =
  | UserEventDetailProject_StandaloneProject_Fragment
  | UserEventDetailProject_Region_Fragment
  | UserEventDetailProject_Market_Fragment
  | UserEventDetailProject_Community_Fragment
  | UserEventDetailProject_Subdivision_Fragment
  | UserEventDetailProject_Lot_Fragment
  | UserEventDetailProject_Structure_Fragment
  | UserEventDetailProject_Unit_Fragment
;

export type UserEventDetailUserEventParentTypeFragment = { __typename?: 'UserEventParentType', id: string, name: string };

export type UserEventDetailUserFragment = { __typename?: 'User', id: string, name: string };

export type UserEvent_CommentFragment = { __typename?: 'Comment', id: string, html: string, author: { __typename?: 'User', name: string, id: string } };

export const UserEventDetailProjectFragmentDoc = gql`
    fragment UserEventDetailProject on Project {
  id
  name
  status {
    code
  }
}
    `;
export const UserEventDetailUserFragmentDoc = gql`
    fragment UserEventDetailUser on User {
  id
  name
}
    `;
export const UserEvent_CommentFragmentDoc = gql`
    fragment UserEvent_Comment on Comment {
  id
  html
  author {
    name
    id
  }
}
    `;
export const UserEventDetailFragmentDoc = gql`
    fragment UserEventDetail on UserEvent {
  id
  type
  createdAt
  payload
  parentTypeName
  parent {
    ... on Named {
      id
      name
    }
    ... on HasBlueprintUrl {
      id
      blueprintUrl {
        path
      }
    }
    ... on JobLog {
      id
      logDate
    }
    ... on JobLogNote {
      id
      jobLog {
        id
        logDate
      }
    }
    ... on JobLogImage {
      id
      jobLog {
        id
        logDate
      }
    }
    ... on Document {
      id
      displayName
    }
  }
  project {
    ...UserEventDetailProject
  }
  cohort {
    ...Named
  }
  development {
    ...Named
  }
  createdFor {
    ...UserEventDetailUser
  }
  createdBy {
    ...UserEventDetailUser
  }
  comment {
    ...UserEvent_Comment
  }
}
    ${UserEventDetailProjectFragmentDoc}
${NamedFragmentDoc}
${UserEventDetailUserFragmentDoc}
${UserEvent_CommentFragmentDoc}`;
export const UserEventDetailUserEventParentTypeFragmentDoc = gql`
    fragment UserEventDetailUserEventParentType on UserEventParentType {
  id
  name
}
    `;
export const UserEventsDocument = gql`
    query UserEvents($filter: UserEventFilter!, $limit: Int!, $order: UserEventOrder!) {
  userEvents(filter: $filter, first: $limit, order: $order) {
    ...UserEventDetail
  }
}
    ${UserEventDetailFragmentDoc}`;

/**
 * __useUserEventsQuery__
 *
 * To run a query within a React component, call `useUserEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserEventsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserEventsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserEventsQuery, UserEventsQueryVariables> & ({ variables: UserEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserEventsQuery, UserEventsQueryVariables>(UserEventsDocument, options);
      }
export function useUserEventsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserEventsQuery, UserEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserEventsQuery, UserEventsQueryVariables>(UserEventsDocument, options);
        }
// @ts-ignore
export function useUserEventsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserEventsQuery, UserEventsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserEventsQuery, UserEventsQueryVariables>;
export function useUserEventsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserEventsQuery, UserEventsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserEventsQuery | undefined, UserEventsQueryVariables>;
export function useUserEventsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserEventsQuery, UserEventsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserEventsQuery, UserEventsQueryVariables>(UserEventsDocument, options);
        }
export type UserEventsQueryHookResult = ReturnType<typeof useUserEventsQuery>;
export type UserEventsLazyQueryHookResult = ReturnType<typeof useUserEventsLazyQuery>;
export type UserEventsSuspenseQueryHookResult = ReturnType<typeof useUserEventsSuspenseQuery>;
export type UserEventsQueryResult = Apollo.QueryResult<UserEventsQuery, UserEventsQueryVariables>;